import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class NavigationController extends BridgeComponent {
  static component = "navigation";
  static targets = ["item"];

  async connect() {
    console.log("[bridge] navigation controller connected");
    const items = this.itemTargets.map((item) => item.dataset.bridgeNavigationItemValue);
    this.send("connect", { items });
  }
}
